module.exports = __webpack_public_path__ + "static/media/ysjp4@2x.80d1d2ff.png";